import casesStatusPresets from './casesStatusPresets';

const sameKinds = (a, b) => ((a.length === b.length) && a.every((kind) => b.includes(kind)));

// Names the preset a standings selection amounts to: active, all, or custom
const casesStatusPresetOf = (statuses) => {
  if (sameKinds(statuses, casesStatusPresets.active)) return 'active';
  if (sameKinds(statuses, casesStatusPresets.all)) return 'all';
  return 'custom';
};

export default casesStatusPresetOf;
